import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CaslinkCommonComponentsModule } from './components/caslink-common-components.module';
import { CaslinkCommonDirectivesModule } from './directives/caslink-common-directives.module';
import { CaslinkCommonPipesModule } from './pipes/caslink-common-pipes.module';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';
import { EmployeeProxyInterceptor } from './interceptors/employeeProxy.interceptor';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        OAuthModule,
        CaslinkCommonDirectivesModule,
        CaslinkCommonPipesModule,
    ],
    exports: [
        CaslinkCommonComponentsModule,
        CaslinkCommonDirectivesModule,
        CaslinkCommonPipesModule
    ]
})
export class CaslinkCommonModule {
    public static forRoot(): ModuleWithProviders<CaslinkCommonModule> {
        return {
            ngModule: CaslinkCommonModule,
            providers: [
                {provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true},
                {provide: HTTP_INTERCEPTORS, useClass: EmployeeProxyInterceptor, multi: true},
                OAuthModule.forRoot({resourceServer: {customUrlValidation: oAuthCustomUrlValidation, sendAccessToken: true}}).providers,
                {provide: OAuthStorage, useFactory: storageFactory}
            ]
        };
    }
}

export function storageFactory(): OAuthStorage {
    return localStorage;
}

export function oAuthCustomUrlValidation(url: string): boolean {
    return !!Object.values(environment.hosts).find(u => url.startsWith(u));
}
